import { inject, observer } from 'mobx-react';
import intersection from 'lodash.intersection';

export const checkPermissions = (user, permissions) => (
  !!intersection(user?.role?.permissions || [], permissions).length || !permissions.length
);

const HasPermission = ({ app: { user }, permissions, children }) => {
  return user.role && checkPermissions(user, permissions) ? children : null;
};

export default inject('app')(observer(HasPermission));
